// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DunningTemplateController = function ($scope, $modal, DocumentTemplate, NumberSequence, DocumentEmailTemplate, EmailTemplatePlaceholder, gettextCatalog, gettext, DunningSettings, SupportedHtmlTagsDescription, salesEntitiesService) {
    salesEntitiesService.query({}, function (response) {
        $scope.salesEntities = response;
        if ($scope.salesEntities.length > 0) {
            $scope.settingsLoaded = true;
        }
        $scope.salesEntityDefault = $scope.salesEntities.find(function (el) {
            return el.IsDefault === true;
        });
        $scope.QRInvoiceType = $scope.salesEntityDefault.PdfSettings.QRInvoiceType;

        $scope.merchantPlaceholders = ['Merchant.CreditorId', 'Merchant.CompanyName', 'Merchant.AddressLine1',
            'Merchant.AddressLine2', 'Merchant.StreetAddress', 'Merchant.HouseNumber', 'Merchant.ZIP', 'Merchant.City',
            'Merchant.Country', 'Merchant.Phone', 'Merchant.Website', 'Merchant.IBAN', 'Merchant.BIC', 'Merchant.EmailAddress'];
        if ($scope.QRInvoiceType === "QRIBANQRReference") 
            $scope.merchantPlaceholders.push('Merchant.QR-IBAN');
    });
    
    var docType = "Dunning";
    $scope.dunningSettings = DunningSettings.get();
    NumberSequence.getDocumentCounterSequences().then(function (data) { $scope.sequences = data; });
    $scope.placeholders = EmailTemplatePlaceholder.query();

    var loadTemplates = function () {
        $scope.templates = DocumentTemplate.query({ documentType: docType }, function (data) {
            if (data && data.length > 0) {
                $scope.selectedTemplateId = data[0].Id;
                $scope.selectTemplate();
            }
            else {
                $scope.selectedTemplateId = null;
                $scope.selectedTemplate = null;
            }
        });
    }

    $scope.selectTemplate = function () {
        for (var i = 0; i < $scope.templates.length; i++) {
            if ($scope.templates[i].Id == $scope.selectedTemplateId) {
                $scope.selectedTemplate = $scope.templates[i];
                getEmailTemplate();
                break;
            }
        }
    }

    $scope.newTemplate = function () {
        var modalInstance = $modal.open({
            templateUrl: 'partials/templateName.html' + $scope.linkVersion,
            controller: TemplateNameController,
            windowClass: "fade in",
            resolve: { title: function () { return gettextCatalog.getString(gettext("New template name")) } }
        });
        modalInstance.result.then(function (result) {
            if (result) {
                var newTemplate = new DocumentTemplate();
                newTemplate.DocumentType = docType;
                newTemplate.Name = result;
                newTemplate.$save(function (data) {
                    $scope.templates.push(data);
                    $scope.selectedTemplateId = data.Id;
                    $scope.selectTemplate();
                });
            }
        });
    }

    $scope.deleteTemplate = function () {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Dunning Template')), gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                DocumentTemplate.remove({ documentType: $scope.selectedTemplate.DocumentType, id: $scope.selectedTemplate.Id },
                    function () {
                        $scope.notifySuccess();
                        loadTemplates();
                    }
                );
            }
        );
    }

    $scope.save = function () {
        if ($scope.selectedTemplate.Id && $scope.selectedTemplate.Id != "000000000000000000000000")
            $scope.selectedTemplate.$update({ documentType: $scope.selectedTemplate.DocumentType, id: $scope.selectedTemplate.Id }, function () {
                $scope.notifySuccess();
            });
        else
            $scope.selectedTemplate.$save(function () {
                $scope.notifySuccess();
            });

        $scope.saveSettings();
    };

    /**
     * Save dunnings settings
     **/

    $scope.saveSettings = function () {
        if($scope.adminOrInRole())
        {
            $scope.dunningSettings.$update( {}, function() {
                //$scope.notifySuccess();
            }, function() {
                $scope.notify( "error", gettextCatalog.getString( gettext( 'An error occurred' ) ) );
            } );
        }
    };



    $scope.delete = function () {

    }

    var getEmailTemplate = function () {
        $scope.emailTemplate = DocumentEmailTemplate.get({ emailType: docType, documentTemplateId: $scope.selectedTemplateId });
        $scope.emailTemplate.EmailType = docType;
        $scope.emailTemplate.DocumentTemplateId = $scope.selectedTemplateId;
    }

    $scope.addLanguage = function (newKey) {
        if ($scope.emailTemplate.Subject[newKey])
            return; // already exists
        $scope.emailTemplate.Subject[newKey] = gettextCatalog.getString(gettext('Subject'));
    };

    $scope.removeLanguage = function (key) {
        $scope.yesCancel(gettextCatalog.getString(gettext("Delete Language")), gettextCatalog.getString(gettext("Are you sure?")), function () {
            delete $scope.emailTemplate.Subject[key];
            delete $scope.emailTemplate.HtmlText[key];
        });
    };

    $scope.saveEmailTemplate = function () {
        if ($scope.emailTemplate.Id != '000000000000000000000000')
            $scope.emailTemplate.$update({ id: docType }, function () { $scope.notifySuccess(); });
        else
            $scope.emailTemplate.$save({}, function () { $scope.notifySuccess(); });
    };

    $scope.generalPlaceholders = ['FirstName', 'LastName', 'CompanyName', 'EmailAddress', 'Customer.ExternalId',
        'ReferenceCode', 'DebitorAccount', 'Customer.CustomFields.****', 'Contract.CustomFields.****',
        'Contract.ExternalId', 'PaymentText', 'Balance', 'Currency'];

    $scope.directDebitPlaceholders = ['Pay.BIC', 'Pay.MaskedBIC', 'Pay.IBAN', 'Pay.MaskedIBAN', 'Pay.Holder', 
        'Pay.BankCode', 'Pay.BankAccount', 'Pay.MandateReference'];

    $scope.creditCardPlaceholders = ['Pay.Last4', 'Pay.Holder', 'Pay.Expiry.Month', 'Pay.Expiry.Year', 'Pay.CardType'];

    $scope.blackLabelProviderPlaceholders = ['Pay.EmailAddress'];
    
    $scope.onAccountPlaceholders = ['Contract.IBAN'];

    SupportedHtmlTagsDescription.get().then(function (text) { $scope.popoverText = text; });

    loadTemplates();

};
DunningTemplateController.$inject = ['$scope', '$uibModal', 'DocumentTemplate', 'NumberSequence', 'DocumentEmailTemplate', 'EmailTemplatePlaceholder', 'gettextCatalog', 'gettext', 'DunningSettings', 'SupportedHtmlTagsDescription', 'SalesEntities'];
